export default {
  auth: () => import("/app/layouts/auth.vue"),
  booking: () => import("/app/layouts/booking.vue"),
  default: () => import("/app/layouts/default.vue")
}